import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 21V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M12 2L2 9.5V10.5L4 11V21H20V11L22 10.5V9.5L12 2Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconHouse.js.map